import { useApolloClient } from '@apollo/client'
import { EmployeeTeamsFilterDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type NumberInFilter = {
  type: 'in'
  label: string
  options: {
    cache?: boolean
    options:
      | Array<{ label: string; value: number }>
      | (() => Promise<Array<{ label: string; value: number }>>)
  }
}

export const useTeamFilter = (): NumberInFilter => {
  const client = useApolloClient()

  return {
    label: i18n.t('employees.employees_list.filters.team'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => {
        const { data } = await client.query({
          query: EmployeeTeamsFilterDocument,
          fetchPolicy: 'cache-first',
        })

        return data.teams.teams.map((team) => ({
          label: team.name,
          value: team.id,
        }))
      },
    },
  }
}
